export default __webpack_public_path__ + "static/media/node.d53df20a.svg";